import styled from "styled-components";

export const SAddProjectModalSectionBreadcrumbBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 48px;
  justify-content: center;
`;
